module.exports = __webpack_public_path__ + "937a5b326927830e25b40da21c43b52f.svg";